import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell, Calendar, RefreshCw, ChevronDown, UserCircle2 } from 'lucide-react';
import GlobalSearch from './GlobalSearch';

export default function Header({ onRefresh }) {
  const nav = useNavigate();
  return (
    <div className="flex items-center justify-between gap-4 mb-4">
      {/* Right cluster */}
      <div className="flex items-center gap-2">
        <div className="panel px-3.5 py-2 flex items-center gap-2.5 min-w-[220px]">
          <div className="icon-chip shrink-0" style={{ background: 'rgba(59,130,246,0.14)', color: '#60A5FA', border: '1px solid rgba(59,130,246,0.25)', width: 30, height: 30 }}>
            <Calendar size={14} />
          </div>
          <div className="text-[11px] leading-tight text-right">
            <div className="text-slate-400">آخر تحديث</div>
            <div className="text-slate-100 font-semibold">08:15 ص • 2025/05/13</div>
          </div>
        </div>
        <button onClick={onRefresh} className="panel panel-hoverable w-11 h-11 flex items-center justify-center text-slate-300 hover:text-white" title="تحديث">
          <RefreshCw size={16} />
        </button>
        <GlobalSearch />
      </div>

      {/* Center title */}
      <div className="flex-1 text-center">
        <h1 className="text-white text-[22px] md:text-[24px] font-extrabold tracking-tight leading-tight">مركز القيادة التنفيذي · المنطقة الجنوبية</h1>
        <p className="text-slate-400 text-[12px] mt-0.5 font-medium">متابعة التجهيزات المدرسية والبلاغات</p>
      </div>

      {/* Left cluster */}
      <div className="flex items-center gap-2">
        <div className="panel px-3 py-2 flex items-center gap-2 min-w-[180px]">
          <ChevronDown size={13} className="text-slate-400" />
          <span className="text-slate-100 text-[12.5px] flex-1 text-center font-semibold">مدير العمليات</span>
          <UserCircle2 size={22} className="text-slate-400" />
        </div>
        <button onClick={() => nav('/alerts')} title="مركز التنبيهات" className="panel panel-hoverable w-11 h-11 flex items-center justify-center text-slate-300 relative">
          <Bell size={16} />
          <span className="absolute -top-1 -left-1 bg-red-500 text-white text-[10px] rounded-full w-5 h-5 flex items-center justify-center font-bold ring-2 ring-[#16181D]">12</span>
        </button>
        <div className="panel px-3 py-2 flex items-center gap-2 min-w-[140px]">
          <span className="relative flex w-2.5 h-2.5">
            <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-40"></span>
            <span className="relative w-2.5 h-2.5 rounded-full bg-green-500"></span>
          </span>
          <div className="text-[11px] leading-tight">
            <div className="text-slate-400">حالة النظام</div>
            <div className="text-green-400 font-semibold">متصل</div>
          </div>
        </div>
      </div>
    </div>
  );
}
